import BenchlingConfig from 'BenchlingConfig';
import {BootstrapUser} from 'util/Types';
interface License {
  granted: boolean;
}

let licenses: {[name: string]: License} = {};

function reload(): void {
  if (window.user != null) {
    ({licenses} = window.user as unknown as BootstrapUser);
  } else {
    licenses = {};
  }
}

export default {
  reload,
  hasLicense(license: string): boolean {
    return (licenses[license] != null ? licenses[license].granted : undefined) || false;
  },
  // TODO(T6580): Use hasEnterprisePlan instead of hasLicense to check for ELN_PRO
  // (a.k.a. Enterprise) license
  hasEnterprisePlan(): boolean {
    return this.hasLicense('LICENSE_REVIEWS');
  },
  // Use hasCommercialLicense to check whether user is a commercial customer vs academic tenant
  hasCommercialLicense(): boolean {
    return BenchlingConfig.PRIVATE_DEPLOY;
  },
};
